import { jsx as e } from "react/jsx-runtime";
import { COLOR as n, GRAPH_NODE_TYPES as d } from "../../../utilities/contants.js";
import { Apartment as c, WifiTethering as a, Place as R, DeviceHub as l } from "@mui/icons-material";
import { r as p } from "../../../chunks/Radio-Indoor-Icon.js";
import { styles as t } from "./NetworkMap.styles.js";
const A = ({
  statusColor: r = n.UNKNOWN
}) => {
  let o = "#C5C8CE";
  return r === n.GREEN ? o = "#0A9918" : r === n.RED ? o = "#E5351B" : r === n.ORANGE && (o = "#FF7A00"), /* @__PURE__ */ e("span", { style: {
    display: "block",
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    backgroundColor: `${o}`
  } });
}, i = {
  edge: /* @__PURE__ */ e(l, { titleAccess: "Edge", sx: t.nodeIcon }),
  site: /* @__PURE__ */ e(R, { titleAccess: "Site", sx: t.nodeIcon }),
  outDoorRadio: /* @__PURE__ */ e(a, { titleAccess: "RadioGroupOutdoor", sx: t.nodeIcon }),
  inDoorRadio: /* @__PURE__ */ e(c, { titleAccess: "RadioGroupIndoor", sx: t.nodeIcon }),
  inDoorRouterRadio: /* @__PURE__ */ e("img", { title: "Radio: Indoor", alt: "Radio Indoor", src: p, style: t.nodeIcon })
}, O = (r) => {
  const {
    nodeType: o,
    zoneType: s
  } = r;
  switch (o) {
    case d.EDGE:
      return i.edge;
    case d.SITE:
      return i.site;
    case d.RADIO_GROUP:
      return s === "INDOOR" ? i.inDoorRadio : i.outDoorRadio;
    case d.RADIO:
      return i.inDoorRouterRadio;
    default:
      return null;
  }
};
export {
  A as circle,
  O as getNodeIcon,
  i as graphIcons
};
